import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=e10040a2&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"
import style0 from "./Access.vue?vue&type=style&index=0&id=e10040a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10040a2",
  null
  
)

export default component.exports